import React, { useState, useEffect, useContext } from 'react';
import {
    FormControlLabel, Checkbox, TextField, InputAdornment, Dialog, DialogTitle, DialogContent, FormControl,
    RadioGroup, Radio, DialogActions, Switch, Avatar, Tooltip
} from "@mui/material";
import { FaStar } from 'react-icons/fa';
import SmsIcon from '@mui/icons-material/Sms';
import EmailIcon from '@mui/icons-material/Email';
import { MdOutlinePhoneIphone } from "react-icons/md";
import PublicIcon from '@mui/icons-material/Public';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { ReactComponent as WhatsappFilled } from '../../../../Assets/img/icons/whatsapp-filled.svg';
import { ReactComponent as VideoCallFilled } from '../../../../Assets/img/icons/video-call-figma.svg';
import { ReactComponent as PaymentFilled } from '../../../../Assets/img/icons/payment-icon-figma.svg';
import VolumeUpRoundedIcon from '@mui/icons-material/VolumeUpRounded';
import ForumIcon from '@mui/icons-material/Forum';
import { ReactComponent as GroupChatFilled } from '../../../../Assets/img/icons/group-chat-figma.svg';
import { ReactComponent as VideoTutorialFilled } from '../../../../Assets/img/icons/video-tutorial-figma.svg';
import { FaSearch } from "react-icons/fa";
import VerifiedIcon from '@mui/icons-material/Verified';
import { useQuantityContext } from '../../../QuantityContext';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Button, IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import BlockIcon from '@mui/icons-material/Block';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import Typography from "@mui/material/Typography";
import CloseIcon from '@mui/icons-material/Close';
import axios from 'axios';
import frame from "../../../../Assets/img/upload-image.png";
import { useNavigate, useParams } from 'react-router-dom';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import { ContactsDetContext } from '../../../ContactsDetContext';
import { ReactComponent as NonVerifiedTickNew } from "../../../../Assets/img/icons/Non-verified-icon.svg";
import { ReactComponent as AdminIcon } from "../../../../Assets/img/icons/Admin_icon.svg";
import useApi from '../../../Utilities/useAPI';
import CryptoJS from 'crypto-js';
import { useUserDetailContext } from '../../../UserDetailContext';

function GroupDetailedView() {
    const { isEnabledCCE, ContactView, setActiveGrpName, activeGrpName } = useQuantityContext();
    const { groupDetailsEdit, setGroupDetailsEdit } = useContext(ContactsDetContext);

    const { userDetails } = useUserDetailContext();
    const { callApiFunction } = useApi();
    const { groupid } = useParams();
    const apiKey = process.env.REACT_APP_API_KEY
    const objectId = localStorage.getItem("objectId");
    const headers = {
        'x-api-key': apiKey,
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${objectId}`
    };

    const [showSubmenu, setShowSubmenu] = useState(false);
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");
    const [filteredMembers, setFilteredMembers] = useState([]);
    const [showDetails, setShowDetails] = useState(isEnabledCCE);
    const [isListView, setIsListView] = useState(ContactView === "List View"); // State to toggle list view
    const [expandedItem, setExpandedItem] = useState(null); // State to track expanded item
    const [openOverflowIndex, setOpenOverflowIndex] = useState([]);
    const [selectedItems, setSelectedItems] = useState({});  // Initialize with an empty object for item selection
    const [selectAll, setSelectAll] = useState(false);
    const [selectAllMembers, setSelectAllMembers] = useState(false);        // State for "Select All" checkbox
    const [groupMembers, setGroupMembers] = useState([]);
    const [deleteConfirm, setdeleteConfirm] = useState(false);
    const [muteContact, setMuteContact] = useState(false);
    const [groupInfoEnable, setGroupInfoEnable] = useState(true);
    const [adminDetails, setAdminDetails] = useState(null);


    const cceFunctions = [
        { icon: VideoCallFilled, function: undefined },
        { icon: WhatsappFilled, function: undefined },
        { icon: ForumIcon, function: undefined },
        { icon: GroupChatFilled, function: undefined },
        { icon: AttachFileIcon, function: undefined },
        { icon: VideoTutorialFilled, function: undefined },
        { icon: VolumeUpRoundedIcon, function: undefined },
        { icon: EmailIcon, function: undefined },
    ];
    const handleSwitchChange = (event) => {
        setGroupInfoEnable(event.target.checked);
    };
    const handleSelectAllChange = () => {
        if (selectAll) {
            setSelectedItems("")
            setSelectAllMembers(false);
        }

        setSelectAll(!selectAll);
    };

    const handleSelectAllMember = () => {
        if (!selectAllMembers) {
            const newSelectedMembers = {};
            filteredMembers.forEach((member) => {
                newSelectedMembers[member.contact_ref_id] = true;
            });
            setSelectedItems(newSelectedMembers);
        } else {
            setSelectedItems("");
        }
        setSelectAllMembers(!selectAllMembers)
    }


    // Handle individual item selection
    const handleItemSelection = (contact_ref_id) => {
        const newSelectedItems = { ...selectedItems, [contact_ref_id]: !selectedItems[contact_ref_id] };
        setSelectedItems(newSelectedItems);

        // Update Select All state if needed
        // const allSelected = filteredMembers.every((member) => newSelectedItems[member.contact_ref_id]);
        // setSelectAll(allSelected);
    };

    useEffect(() => {
        setShowDetails(isEnabledCCE);
    }, [isEnabledCCE]);

    useEffect(() => {
        setIsListView(ContactView === "List View");
    }, [ContactView]);

    useEffect(() => {
        setFilteredMembers(
            groupMembers.filter(member =>
                member.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                member.role.toLowerCase().includes(searchTerm.toLowerCase())
            )
        );
    }, [searchTerm, groupMembers]);

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };

    function generateRandomDate() {
        const start = new Date(2020, 0, 1); // Start date (1st January 2020)
        const end = new Date(); // Current date
        const randomDate = new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime()));

        // Format the date as 'Apr 21, 2024'
        const options = { year: 'numeric', month: 'short', day: 'numeric' };
        return randomDate.toLocaleDateString('en-US', options);
    }

    const toggleOverflow = (index) => {
        setOpenOverflowIndex((prev) => {
            const newState = [...prev];
            newState[index] = !newState[index];
            return newState;
        });
    };

    const toggleExpand = (index) => {
        if (expandedItem === index) {
            setExpandedItem(null); // Collapse if already expanded
        } else {
            setExpandedItem(index); // Expand the clicked item
        }
    };

    const formatDateAndTime = (createdAt) => {
        const date = new Date(createdAt);

        // Format time as 12-hour format with AM/PM
        const timeFormatter = new Intl.DateTimeFormat('en-US', {
            hour: 'numeric',
            minute: 'numeric',
            hour12: true
        });
        const formattedTime = timeFormatter.format(date); // e.g., 12:42 PM

        // Format date as DD Month YYYY
        const dateFormatter = new Intl.DateTimeFormat('en-GB', {
            day: 'numeric',
            month: 'long',
            year: 'numeric'
        });
        let formattedDate = dateFormatter.format(date); // e.g., 13 May 2024
        const [day, month, year] = formattedDate.split(' ');

        const abbreviatedMonth = month.length > 4 ? month.slice(0, 3).toUpperCase() : month;

        formattedDate = `${day} ${abbreviatedMonth} ${year}`; // e.g., 13 Sept 2024

        return { formattedTime, formattedDate };
    };

    useEffect(() => {
        // Fetch contacts from the API
        const fetchContacts = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/usercontact/groups/${groupid}`, {
                    headers: headers
                });

                const data = response.data;
                const editable = data.is_editable;

                if (data.statusCode === 200) {
                    const members = data.members.map(member => {
                        const role = member.designation || member.field_of_study || member.title || '---';
                        const subTitle = member.profession_department || member.institute || member.nickname || '---';

                        return {
                            contact_ref_id: member.user_ref_id,
                            img: member.profile_url,  // Use default image if profile_url is null
                            name: `${member.first_name} ${member.last_name}`,
                            role: role,  // New role assignment
                            subTitle: subTitle,  // New subTitle assignment
                            verified: member.is_verified ? true : false,
                            phone_no: member.phone_no?.replace(/[\s-]/g, ''),
                            email: member.email?.trim(),
                            contact_role: member?.role
                        };
                    });
                    const admin = members.find(member => member.contact_ref_id === data.groupDetails.user_ref_id);
                    setAdminDetails(admin); // Set the admin details

                    const adminMembers = members.filter(member => member.contact_role === "ADMIN");


                    setGroupMembers(members);
                    setFilteredMembers(members);

                    const { group_id, group_name, group_type, group_category, group_subname, group_desc, group_image, created_at, user_ref_id } = data.groupDetails;
                    setActiveGrpName(group_name);
                    const { formattedTime, formattedDate } = formatDateAndTime(created_at);

                    setGroupDetailsEdit(prevDetails => ({
                        ...prevDetails,

                        group_id,
                        group_name,
                        group_type,
                        group_category,
                        group_subname,
                        group_desc,
                        admins: adminMembers || [],
                        group_image: group_image && group_image.trim() !== "" ? group_image : frame,
                        members,  // Add members to groupDetails
                        is_editable: editable,
                        created_at_time: formattedTime,  // Add the formatted time
                        created_at_date: formattedDate,
                        user_ref_id,
                        // Add the formatted date
                    }));
                }
            } catch (err) {
                console.log('An error occurred while fetching the contacts:', err);
            }
        };

        fetchContacts();
    }, []);

    const handleDelete = async () => {
        const contact_ref_ids = Object.keys(selectedItems)
            .filter(id => selectedItems[id])
            .map(id => parseInt(id, 10)); // Ensure IDs are integers

        // Update selectedGroupMembers and filteredMembers by removing deleted contacts
        setGroupMembers((prevMembers) => {
            // console.log("Before filter:", prevMembers);
            // console.log("IDs to delete:", contact_ref_ids);
            const updatedMembers = prevMembers.filter((member) => !contact_ref_ids.includes(member.contact_ref_id));
            // console.log("After filter:", updatedMembers);
            return updatedMembers;
        });

        setFilteredMembers((prevMembers) => {
            const updatedMembers = prevMembers.filter((member) => !contact_ref_ids.includes(member.contact_ref_id));
            return updatedMembers;
        });

        // Optionally, clear the selected items if needed
        setSelectedItems((prevSelectedItems) => {
            const updatedSelectedItems = { ...prevSelectedItems };
            contact_ref_ids.forEach(id => {
                delete updatedSelectedItems[id];
            });
            return updatedSelectedItems;
        });

        setdeleteConfirm(false);
        // console.log("this is contact reference ID", contact_ref_ids)
        try {

            const response = await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/groups/deleteGroup/${groupid}`, {
                headers: headers
            });
            // const response = await callApiFunction('deleteContacts', {
            //     contact_ref_ids: contact_ref_ids,
            // });
            // console.log("this is contact reference ID", contact_ref_ids);
            // console.log("Deleted Successfully", response);
            // if (!response.ok) {
            //     throw new Error(`API error: ${response.status} ${response.statusText}`);
            // }

            // // Try to parse JSON response
            // const data = await response.json();
            // console.log("Parsed response:", data);
        } catch (error) {
            console.log('Error uploading file:', error.message);
        }


    }

    const handleSaveMute = () => {
    }

    const navigateEditPage = () => {
        navigate("/edit_group");
    }

    const handleNavigate = (id) => {

        if (id == userDetails?.reference_id) {
            navigate("/myprofile");
        }
        else {
            const encryptedId = CryptoJS.AES.encrypt(id.toString(), 'UserDetailsSecretKey').toString();
            // navigate(`/userDetailedInfo/${encodeURIComponent(encryptedId)}`);
            navigate(`/userDetailedInfo?encryptedId=${encodeURIComponent(encryptedId)}`);
            // navigate(`/userDetailedInfo/${id}`)
        }

    }
    const selectedContacts = Object.keys(selectedItems).filter(key => selectedItems[key]);
    const submenuDisplay = showSubmenu ? 'flex' : 'none';

    return (
        <div className="outer-layer-of-contacts">
            <div className="outer-container h-100">
                <div className="displayflex justify-content-between align-items-center">
                    <h6 className="fw-bold">{activeGrpName}</h6>
                    <div className="flex-center">
                        {!isListView &&
                            <>
                                <div className="">
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={groupInfoEnable}
                                                onChange={handleSwitchChange} />}
                                        label="Group Info"
                                        sx={{ color: groupInfoEnable ? '#0044c6' : '#00000099' }} />
                                </div>
                                <div className="">
                                    {selectAll && <FormControlLabel
                                        className='customized_formControl'
                                        control={<Checkbox checked={selectAllMembers} onChange={handleSelectAllMember} />}
                                        label="Select All"
                                        sx={{ color: selectAll ? '#0044c6' : '#00000099' }}
                                    />}

                                    <FormControlLabel
                                        className='customized_formControl'
                                        control={<Checkbox checked={selectAll} onChange={handleSelectAllChange} />}
                                        label="Select"
                                        sx={{ color: selectAll ? '#0044c6' : '#00000099' }}
                                    />
                                </div></>}
                        <div style={{ marginRight: '10px' }}>
                            <TextField
                                placeholder="Search..."
                                variant="outlined"
                                size="small"
                                className="me-2"
                                value={searchTerm}
                                onChange={handleSearchChange}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <div className="icon">
                                                <FaSearch className="icon-color" />
                                            </div>
                                        </InputAdornment>
                                    ),
                                }}
                                style={{ width: '320px' }}
                            />
                        </div>
                    </div>
                </div>

                <div className='d-flex flex-row h-100'>

                    {(!isListView && groupInfoEnable) &&
                        <div className="groupInfo-details-container d-flex flex-column align-items-center justify-content-between p-2 mt-3 me-3" style={{ position: "relative" }}>
                            <div>
                                <h5 className="sub-heading-style-16 text-center mt-1 mb-5">Group Details</h5>
                                <div className='w-100 flex-center'>
                                    <div className='group_image_size'>
                                        <img
                                            src={groupDetailsEdit.group_image}
                                            alt={groupDetailsEdit.group_name}
                                            className='cover-image'
                                        />
                                    </div>
                                </div>
                                <h5 className='my-2 fw-bold heading-fav text-center'>{groupDetailsEdit.group_name}</h5>
                                {groupDetailsEdit.group_subname &&
                                    <p className='sub-heading-style-16 text-center'>({groupDetailsEdit.group_subname})</p>
                                }
                                <p className='sub-heading-style-16 text-center mt-3'>{groupDetailsEdit.group_desc}</p>
                                <div className="group-metaInfo d-flex flex-column gap-2 mt-3">
                                    <div className='icon-20px d-flex align-items-center'>
                                        <AccessTimeFilledIcon className='icon-color' style={{ marginRight: '6px', color: '#6c757d' }} />
                                        <span className='sub-heading-style-16'>{groupDetailsEdit.created_at_time}</span>
                                    </div>
                                    <div className='icon-20px d-flex align-items-center'>
                                        <CalendarTodayIcon className='icon-color' style={{ marginRight: '6px', color: '#6c757d' }} />
                                        <span className='sub-heading-style-16'>{groupDetailsEdit.created_at_date}</span>
                                    </div>
                                </div>

                                {adminDetails && (
                                    <div className='owner_group_det p-2'>
                                        <div className='d-flex align-items-center'>
                                            <Avatar
                                                src={adminDetails.img}
                                                alt={adminDetails.name}
                                                sx={{ width: 38, height: 38, marginRight: 1 }}
                                            >{adminDetails.name.charAt(0).toUpperCase()}</Avatar>
                                            <div className='d-flex align-items-center justify-content-start gap-2'>
                                                Owner |
                                                <AdminIcon /> {/* Admin Icon */}
                                            </div>
                                        </div>
                                        <div className="ms-1 mt-1 group_permissions_subtitle fw-bold">{adminDetails.name}</div> {/* Admin's name */}
                                    </div>
                                )}
                            </div>
                            {groupDetailsEdit.is_editable &&
                                <div className='flex-center'>
                                    <Button
                                        variant="contained"
                                        onClick={navigateEditPage}
                                        style={{ backgroundColor: '#0044c6', color: '#fff', marginTop: '5px' }}>
                                        Edit
                                    </Button>
                                </div>
                            }
                        </div>}

                    {!isListView ? (
                        <div className="avatars-container">
                            {filteredMembers.map((member, index) => (
                                <div key={index} className={`avatar-box-outer ${!showDetails ? 'compact' : ''}`}>
                                    <div className={`avatar-box t ${!showDetails ? 'compact' : ''}`}>
                                        <div className="flex-center avatar-details-wrapper pointer" onClick={() => { handleNavigate(member.contact_ref_id) }}>

                                            {selectAll ? (
                                                <div className="dot_status_contacts">
                                                    <Checkbox
                                                        checked={selectedItems[member.contact_ref_id] || false}
                                                        onClick={(e) => e.stopPropagation()} // Prevent click propagation
                                                        onChange={(e) => {
                                                            e.stopPropagation(); // Stop event from bubbling up
                                                            handleItemSelection(member.contact_ref_id);
                                                        }}
                                                        className="member-checkbox p-0"
                                                    />
                                                </div>
                                            ) : (
                                                <div className="dot_status_contacts"
                                                    style={{ backgroundColor: member.verified ? "#43A047" : "#EB4E3D" }}></div>
                                            )}

                                            <div className='star_fav_cards' onClick={(e) => {
                                                e.stopPropagation();
                                            }}>
                                            </div>
                                            <div className="avatar-details t">
                                                <div>
                                                    <div className="avatar-image t">
                                                        {/* <img className='cover-image' src={member.img} alt={member.name} /> */}
                                                        <Avatar
                                                            className="w-100 h-100 cover-image" style={{ fontSize: "3rem" }}
                                                            alt={member.name}
                                                            src={member.img || undefined}
                                                        >{member.name.charAt(0).toUpperCase()}</Avatar>
                                                    </div>
                                                </div>
                                                {/* {showDetails && <div className="vertical-line"></div>} */}
                                                <div className="member-info mt-1 word-break">
                                                    <Tooltip title={member.name} placement="bottom">
                                                        <div className="member-name">
                                                            {member.name.length > 10
                                                                ? `${member.name.slice(0, 10)}...`
                                                                : member.name}
                                                        </div>
                                                    </Tooltip>
                                                    <div className="member-role">{member.role}</div>
                                                    {showDetails && <div className="member-email truncate">{member.subTitle}</div>}
                                                </div>
                                            </div>
                                        </div>

                                        {showDetails && (
                                            <>
                                                <div className="icons-container">
                                                    <a href={`tel:${member?.phone_no}`} target='_blank' rel='noreferrer' className='icon-box flex-center flex-column' >
                                                        <div className=""><MdOutlinePhoneIphone className="icon" /></div>
                                                    </a>
                                                    <a href={`sms:${member?.phone_no}`} target='_blank' rel='noreferrer' className='icon-box flex-center flex-column' >
                                                        <div className=""><SmsIcon className="icon" /></div>
                                                    </a>
                                                    <a href={`mailto:${member?.email}`} target='_blank' rel='noreferrer' className='icon-box flex-center flex-column' >
                                                        <div className=""><EmailIcon className="icon" /></div>
                                                    </a>
                                                    <a href={`https://wa.me/${member?.phone_no}`} target='_blank' rel='noreferrer' className='icon-box flex-center flex-column' >
                                                        <div className=""><WhatsappFilled className="icon figma-icon" /></div>
                                                    </a>
                                                    <div className="icon-box"><MoreHorizIcon className="icon" onClick={() => toggleOverflow(index)} /></div>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                    {showDetails && openOverflowIndex[index] && (
                                        <>
                                            <div className="overflow-menu icons-container ms-2">
                                                <div className="icon-box"><AttachFileIcon className="icon" /></div>
                                                <div className="icon-box"><PublicIcon className="icon" /></div>
                                                <div className="icon-box"><VideoCallFilled className="icon figma-icon" /></div>
                                                <div className="icon-box"><VolumeUpRoundedIcon className="icon" /></div>
                                                <div className="icon-box"><PaymentFilled className="icon figma-icon" /></div>
                                            </div>
                                        </>
                                    )}
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="list-container w-100">
                            <ul className="members">
                                {/* Column headers */}
                                <div className="header-row">
                                    <div className="header-column select-all me-3">
                                        <FormControlLabel
                                            className='customized_formControl ms-3'
                                            control={<Checkbox checked={selectAllMembers} onChange={handleSelectAllMember} className='ps-0' />}
                                            label="Select All"
                                        />
                                    </div>
                                    <div className="header-column name-email-details-column">
                                        Name and Email
                                    </div>
                                    <div className="header-column name-email-details-column">
                                        Details
                                    </div>
                                    <div className="header-column date">
                                        Date
                                    </div>
                                    <div className="header-column actions">
                                        Actions
                                    </div>
                                </div>
                                {filteredMembers.map((member, index) => (
                                    <div key={index} className={`list-item-container ${expandedItem === index ? 'expanded' : ''}`}>
                                        <li key={index} className={`list-item ${expandedItem === index ? 'expanded' : ''}`} onClick={() => { handleNavigate(member.contact_ref_id) }}>
                                            <div className='d-flex align-items-center header-column select-all ms-3' style={{ position: "relative" }}>
                                                <Checkbox onClick={(e) => e.stopPropagation()}
                                                    checked={selectedItems[member.contact_ref_id] || false}  // Changed to contact_ref_id
                                                    onChange={() => handleItemSelection(member.contact_ref_id)}  // Changed to contact_ref_id
                                                    className="member-checkbox p-0"
                                                />
                                                <div className="list-avatar" style={{ position: "absolute", right: "10%" }}>
                                                    <div className='w-100 h-100' style={{ position: "relative" }}>
                                                        <Avatar style={{ fontSize: "2rem" }}
                                                            className="w-100 h-100 cover-image"
                                                            alt={member.name}
                                                            src={member.img || undefined}
                                                        >{member.name.charAt(0).toUpperCase()}</Avatar>

                                                        <div className={`symbol_of_contacts2_list`}>
                                                            {member.verified ?
                                                                <VerifiedIcon style={{ color: "#43A047" }} /> :
                                                                <NonVerifiedTickNew />
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="name-email-details header-column name-email-details-column">
                                                <span className="list-name">{member.name}</span>
                                                <span className="list-email">{member.subTitle}</span>
                                            </div>
                                            <span className="list-role header-column name-email-details-column">{member.role}</span>
                                            <span className="list-date header-column date">{generateRandomDate()}</span>
                                            <span className="list-actions header-column actions align-items-center icon-20px" onClick={(e) => e.stopPropagation()}>

                                                <MoreVertIcon className={`ms-2 ${expandedItem === index ? 'color-blue' : 'icon-color'}`} onClick={() => toggleExpand(index)} />
                                            </span>

                                            {expandedItem === index && (
                                                <div className="group-options-bar additional-info">
                                                    <a href={`mailto:${member?.email}`} target='_blank' rel='noreferrer'>
                                                        <div className="group-option-box" onClick={(e) => e.stopPropagation()} >
                                                            <EmailIcon className="pointer" />
                                                        </div>
                                                    </a>
                                                    <a href={`https://wa.me/${member?.phone_no}`} target='_blank' rel='noreferrer' >
                                                        <div className="group-option-box" onClick={(e) => e.stopPropagation()}>
                                                            <WhatsappFilled className="pointer figma-icon" />
                                                        </div>
                                                    </a>
                                                    <a href={`sms:${member?.phone_no}`} target='_blank' rel='noreferrer' >
                                                        <div className="group-option-box" onClick={(e) => e.stopPropagation()}>
                                                            <GroupChatFilled className="pointer figma-icon" />
                                                        </div>
                                                    </a>
                                                    <a href={`sms:${member?.phone_no}`} target='_blank' rel='noreferrer' >
                                                        <div className="group-option-box" onClick={(e) => e.stopPropagation()}>
                                                            <ForumIcon className="pointer" />
                                                        </div>
                                                    </a>
                                                    <div className="group-option-box" onClick={(e) => e.stopPropagation()}>
                                                        <VolumeUpRoundedIcon className="pointer" />
                                                    </div>
                                                    <div className="group-option-box" onClick={(e) => e.stopPropagation()}>
                                                        <VideoTutorialFilled className="pointer figma-icon" />
                                                    </div>
                                                    <div className="group-option-box" onClick={(e) => e.stopPropagation()}>
                                                        <AttachFileIcon className="pointer figma-icon" />
                                                    </div>
                                                    <div className="group-option-box" onClick={(e) => e.stopPropagation()}>
                                                        <VideoCallFilled className="pointer figma-icon" />
                                                    </div>
                                                </div>
                                            )}
                                        </li>
                                    </div>
                                ))}
                            </ul>
                        </div>
                    )}
                </div>
            </div>

            {
                selectedContacts.length > 0 && (
                    <div className={`action-bar ${Object.keys(selectedItems).length > 0 ? 'open' : ''}`}>

                        {cceFunctions.map((item, index) => {
                            const SvgIcon = item.icon; // Get the component reference
                            return (
                                <a href={item.href} target="_blank" rel="noreferrer" key={index}>
                                    <IconButton className="white-icon-hover me-4" onClick={item.function} key={index}>
                                        <SvgIcon className='white-svg svg-icon-32px' />
                                    </IconButton>
                                </a>
                            )
                        })}
                    </div>
                )
            }

            <LayoutBox deleteConfirm={deleteConfirm} setdeleteConfirm={setdeleteConfirm} handleDeleteCard={handleDelete}
                muteContact={muteContact} setMuteContact={setMuteContact} handleSaveMute={handleSaveMute} />
        </div >
    );
}

const LayoutBox = ({ deleteConfirm, setdeleteConfirm, handleDeleteCard, muteContact, setMuteContact, handleSaveMute }) => {

    const [selectedOption, setSelectedOption] = useState('');

    const handleChange = (event) => {
        setSelectedOption(event.target.value);
    };

    return (
        <>
            {deleteConfirm &&
                <div className="lightbox-overlay">
                    <div className="lightbox-content p-4" style={{ minWidth: "40%" }}>
                        <div className='d-flex align-items-center justify-content-between'>
                            <h6 className='mb-0' style={{ fontSize: "16px", fontWeight: "bold", color: "black" }}>Delete the Contact</h6>
                            <IconButton onClick={() => setdeleteConfirm(false)}>
                                <CloseRoundedIcon />
                            </IconButton>
                        </div>

                        <Typography variant="body2" className="text-muted">Person will be deleted from your Contact. Are you sure you want to delete?</Typography>

                        <div className='d-flex justify-content-end'>
                            <Button onClick={() => setdeleteConfirm(false)} className="mx-2 mt-2">
                                CANCEL
                            </Button>
                            <Button onClick={handleDeleteCard} className="delete-button_configuration mt-2">
                                DELETE
                            </Button>
                        </div>

                    </div>
                </div>
            }

            <Dialog open={muteContact} onClose={() => { setMuteContact(false) }} maxWidth="sm">
                <DialogTitle className='d-flex'>
                    Mute the Contact
                    <IconButton
                        aria-label="close"
                        onClick={() => { setMuteContact(false) }}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 10,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <FormControl component="fieldset">
                        <RadioGroup value={selectedOption} onChange={handleChange}>
                            <FormControlLabel value="1 hour" control={<Radio />} label="1 hour" />
                            <FormControlLabel value="8 hours" control={<Radio />} label="8 hours" />
                            <FormControlLabel value="7 days" control={<Radio />} label="7 days" />
                            <FormControlLabel value="indefinite" control={<Radio />} label="Until I Turn It Back On" />
                        </RadioGroup>
                    </FormControl>
                </DialogContent>
                <DialogActions>
                    <div className='d-flex justify-content-end'>
                        <Button onClick={() => setMuteContact(false)} className="me-3" style={{ color: "#0044c6" }}>
                            CANCEL
                        </Button>
                        <Button onClick={() => { handleSaveMute(selectedOption) }} variant="contained" className='color-blue' sx={{ backgroundColor: "#0044C6" }}
                            style={{ marginBottom: "10px", marginRight: "10px" }}>
                            Save
                        </Button>
                    </div>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default GroupDetailedView;
